import { useEffect, useMemo } from 'react';
import { fillEmptyValues } from './form-values';
import { deepEqual } from 'fast-equals';
import { normalizeValues } from './normalize-values';
export const useFormValues = (form, values, onChange) => {
    const normalizedValues = useMemo(() => normalizeValues(form, fillEmptyValues(form, values)), [form, values]);
    useEffect(() => {
        const hasAnyValueChanged = !deepEqual(normalizedValues, values);
        if (hasAnyValueChanged) {
            onChange === null || onChange === void 0 ? void 0 : onChange(normalizedValues);
        }
    }, [values, normalizedValues, onChange]);
    return normalizedValues;
};
//# sourceMappingURL=use-form-values.js.map